import React, { memo, Fragment } from 'react';
import { LatexComponent } from 'components/HHQComponents';
import { TestDetailQuizModel } from 'models/test-detail.model';
import './index.css';
interface PropTypes {
    question: TestDetailQuizModel;
    showTruth: boolean;
}

const TCHDungSaiComponent: React.FC<PropTypes> = ({ question, showTruth }) => {
  const selectedIndex = question.userAnswer?.length ? +question.userAnswer[0] : -1;

  return (
    <div>
      {(question.testQuestionAnswers || []).map((answer, index) => {
        const isSelected = selectedIndex === index;
        const isCorrect = answer.isCorrect === 1;
        const showHint = isSelected && !!answer.comment;
        const showCorrectMark = !question.stockPoint && isCorrect && showTruth;

        return (
          <Fragment key={`answer-dung-sai-${question.id}-${index}`}>
            <div className="question-content--item border-top-dashed-gray-200 mt-2 pt-2">
              <label htmlFor="" className="custom-checkbox">
                <input
                  disabled
                  type="radio"
                  name={question.id}
                  value={answer?.answer}
                  checked={isSelected}
                  id={`dung-sai${question.id}${index}`}
                />

                <label htmlFor={`dung-sai${question.id}${index}`}>
                  <div>
                    <span
                      className={
                        answer?.answer
                          ? 'text-green-600 text-bolder'
                          : 'text-red-600 text-bolder'
                      }
                    >
                      {answer?.answer || ''}
                    </span>

                    {showHint && (
                      <div>
                        <div>- Gợi ý: </div>
                        <LatexComponent>
                          <div
                            dangerouslySetInnerHTML={{
                              __html: answer.comment || '',
                            }}
                          />
                        </LatexComponent>
                      </div>
                    )}

                    {showCorrectMark && (
                      <small
                        className="result-truth checkbox text-bolder text-green-400"
                        title="Đáp án đúng"
                      >
                        <i className="pi pi-check-square font-size-22" />
                      </small>
                    )}
                  </div>
                </label>
              </label>
            </div>
          </Fragment>
        );
      })}
    </div>
  );
};

export default memo(TCHDungSaiComponent);
